var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSymbolWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 86,
    viewBox: "0 0 85 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_4087_215588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.1479 65.7168H42.0003C36.5657 65.7168 32.1423 61.2941 32.1423 55.8601V30.5791C32.1423 29.3234 31.1199 28.3066 29.8696 28.3066C28.6137 28.3066 27.5912 29.329 27.5912 30.5791V43.7197C27.5912 44.9754 28.6137 45.9922 29.8696 45.9922H30.8809V47.509H29.8696C27.7802 47.509 26.0742 45.8089 26.0742 43.7197V30.5736C26.0742 28.4845 27.7746 26.7842 29.8696 26.7842C31.959 26.7842 33.6594 28.4845 33.6594 30.5736V55.8545C33.6594 60.4551 37.4047 64.1944 42.0003 64.1944H55.1479C59.749 64.1944 63.4888 60.4495 63.4888 55.8545C63.4888 51.2539 59.7435 47.509 55.1479 47.509H40.9834V45.9977H55.1424C60.577 45.9977 65.0003 50.4205 65.0003 55.8601C65.0059 61.2941 60.5825 65.7168 55.1479 65.7168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1473 59.6494H41.9997C39.9103 59.6494 38.21 57.9492 38.21 55.8601V30.5792C38.21 25.9786 34.4646 22.2393 29.8635 22.2393C25.2624 22.2393 21.517 25.9786 21.517 30.5736V43.7197C21.517 48.3203 25.2624 52.0596 29.8635 52.0596H30.8749V53.5764H29.8635C24.4233 53.582 20 49.1592 20 43.7197V30.5736C20 25.1396 24.4233 20.7169 29.858 20.7169C35.2926 20.7169 39.7214 25.1396 39.7214 30.5736V55.8546C39.7214 57.1102 40.7439 58.1271 41.9942 58.1271H55.1418C56.3977 58.1271 57.4146 57.1047 57.4146 55.8546C57.4146 54.5988 56.3921 53.5764 55.1418 53.5764H40.9828V52.0596H55.1418C57.2312 52.0596 58.9316 53.7598 58.9316 55.8546C58.9372 57.9492 57.2368 59.6494 55.1473 59.6494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.147 62.6828H41.9994C38.2374 62.6828 35.1756 59.6213 35.1756 55.8598V30.5789C35.1756 27.6507 32.7916 25.2727 29.8688 25.2727C26.9458 25.2727 24.5563 27.6563 24.5563 30.5789V43.7194C24.5563 46.6476 26.9403 49.0257 29.8688 49.0257H30.8801V50.5425H29.8688C26.1067 50.5425 23.0393 47.481 23.0393 43.7194V30.5733C23.0393 26.8118 26.1012 23.7503 29.8632 23.7503C33.6252 23.7503 36.6926 26.8118 36.6926 30.5733V55.8542C36.6926 58.7824 39.0765 61.1604 41.9994 61.1604H55.147C58.0755 61.1604 60.4539 58.7768 60.4539 55.8542C60.4539 52.9261 58.07 50.5425 55.147 50.5425H40.9825V49.0257H55.1415C58.9036 49.0257 61.9654 52.0871 61.9654 55.8542C61.9654 59.6213 58.9091 62.6828 55.147 62.6828Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_4087_215588",
    x: 0,
    y: 0.71685,
    width: 85.0004,
    height: 85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4087_215588"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4087_215588",
    result: "effect2_dropShadow_4087_215588"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4087_215588",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSymbolWhite);
export default __webpack_public_path__ + "static/media/logo_symbol_white.5ca33191d74bba286bcbba2c4238f72e.svg";
export { ForwardRef as ReactComponent };